import classNames from 'classnames';
import {
  NavLink,
  NavLinkProps,
} from 'react-router-dom';

import {
  LocalizedLink,
  LocalizedLinkProps,
} from '@ui/LocalizedLink';

// styles
import s from './Tab.sss';

type TabProps = NavLinkProps | LocalizedLinkProps;

export const Tab: React.FC<TabProps> = ({
  className,
  ...props
}) => (
  'href' in props
    ? (
      <LocalizedLink
        theme="clean"
        {...(props as LocalizedLinkProps)}
        className={classNames(s.link, className)}
      />
    )
    : (
      <NavLink
        {...props}
        className={classNames(s.link, className)}
        activeClassName={classNames(s.active, props.activeClassName)}
      />
    )
);

export default Tab;
